import { render, staticRenderFns } from "./CategoriaView.vue?vue&type=template&id=bd6af6a8&"
import script from "./CategoriaView.vue?vue&type=script&lang=ts&"
export * from "./CategoriaView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports